import globals from '@/globals';

const { context } = globals;

function logAction(action, ...args) {
  const method = context.console[action];
  if (method) {
    method(...args);
  }
}

export default {
  log: (...args) => logAction('log', ...args),
  info: (...args) => logAction('info', ...args),
  warn: (...args) => logAction('warn', ...args),
  error: (...args) => logAction('error', ...args),
  debug: (...args) => logAction('debug', ...args),
};
